import { Observable } from 'rxjs';

import { CollageProcess, CollageProcessResponse } from '@mirage-projects/cw-models';

import { ProcessFilter } from '../models';

export abstract class ProcessService {
    /**
     * Filter the processes
     */
    abstract filter(processFilter: ProcessFilter): Observable<CollageProcessResponse>;
    abstract get(uuid: string): Observable<CollageProcess>;
    abstract cancel(uuid: string): Observable<void>;
    abstract getByExternal(processUuid: string): Observable<CollageProcess>;
}
